module.exports = __webpack_public_path__ + "static/img/coupons.987af57.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/collectCustomerInfo/studentDriver/static/coupons.png
// module id = lFoe
// module chunks = 1